/**
 * Lead table column IDs
 * Used for column identification, sorting, and rendering
 */
export enum LeadsTableColumnId {
	NAME = 'name',
	PREQUAL_STATUS = 'prequalStatus',
	EMAIL = 'email',
	PHONE = 'phone',
	PIPELINE = 'pipeline',
	STAGE = 'stage',
	TYPE = 'type',
	VEHICLE_INTERESTS = 'vehicleInterests',
	DEAL_AMOUNT = 'dealAmount',
	ACCOUNT_NAME = 'accountName',
	DATE_CREATED = 'dateCreated',
	LAST_UPDATED = 'lastUpdated',
	TASKS = 'tasks',
	ACTIONS = 'actions',
}
